import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL, ADMIN_API_BASE_URL } from '../../config';
import { Utilities } from '../../utilities';

/**
 * HTTP Interceptor that adds a unique request ID header to API requests.
 *
 * This enables distributed tracing and debugging by providing a unique
 * identifier for each request that can be correlated across services.
 *
 * Headers added:
 * - `x-request-id` - Unique UUID v4 for each request
 *
 * @example
 * { provide: HTTP_INTERCEPTORS, useClass: RequestTracingInterceptor, multi: true }
 */
@Injectable({
  providedIn: 'root'
})
export class RequestTracingInterceptor implements HttpInterceptor {
  private baseUrl = inject(API_BASE_URL);
  private adminUrl = inject(ADMIN_API_BASE_URL);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.indexOf(this.adminUrl) > -1 || request.url.indexOf(this.baseUrl) > -1) {
      return this.addRequestIdHeader(request, next);
    }
    return next.handle(request);
  }

  private addRequestIdHeader(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Preserve existing headers
    const headerSettings: { [name: string]: string | string[]; } = {};
    for (const key of request.headers.keys()) {
      headerSettings[key] = request.headers.getAll(key);
    }

    headerSettings['x-request-id'] = Utilities.generateUuid();

    const newHeader = new HttpHeaders(headerSettings);
    const changedRequest = request.clone({ headers: newHeader });
    return next.handle(changedRequest);
  }
}
